export const actionTypes = {
  CREATE_SURVEY: 'CREATE_SURVEY',
  CREATE_SURVEY_SUCCESS: 'CREATE_SURVEY_SUCCESS',
  GET_SURVEY: 'GET_SURVEY',
  GET_SURVEY_SUCCESS: 'GET_SURVEY_SUCCESS',
  UPDATE_SURVEY: 'UPDATE_SURVEY',
  UPDATE_SURVEY_SUCCESS: 'UPDATE_SURVEY_SUCCESS',
  GET_STATIC_VALUES: 'GET_STATIC_VALUES',
  GET_STATIC_VALUES_SUCCESS: 'GET_STATIC_VALUES_SUCCESS',
  CREATE_SURVEY_SERIES: 'CREATE_SURVEY_SERIES',
  CREATE_SURVEY_SERIES_SUCCESS: 'CREATE_SURVEY_SERIES_SUCCESS',
  GET_SURVEY_SERIES: 'GET_SURVEY_SERIES',
  GET_SURVEY_SERIES_SUCCESS: 'GET_SURVEY_SERIES_SUCCESS',
  GET_SURVEY_SERIES_BY_ID: 'GET_SURVEY_SERIES_BY_ID',
  GET_SURVEY_SERIES_BY_ID_SUCCESS: 'GET_SURVEY_SERIES_BY_ID_SUCCESS',
  CLONE_SURVEY: 'CLONE_SURVEY',
  CLOSE_SURVEY: 'CLOSE_SURVEY',
  PUBLISH_SURVEY: 'PUBLISH_SURVEY',
  UPDATE_SURVEY_SERIES: 'UPDATE_SURVEY_SERIES',
  REOPEN_SURVEY: 'REOPEN_SURVEY',
  SAVE_NOTES: 'SAVE_NOTES',
  GET_CC_EMAIL: 'GET_CC_EMAIL',
  UPDATE_CC_EMAIL: 'UPDATE_CC_EMAIL',
};

export const createSurvey = (data, callback = (_res: { id: string }, _message: string) => {}) => ({
  type: actionTypes.CREATE_SURVEY,
  callback,
  payload: data,
});

export const createSurveySuccess = data => ({
  type: actionTypes.CREATE_SURVEY_SUCCESS,
  payload: data,
});

export const getSurvey = (id: string, callback = (_res: any, _message: string) => {}) => ({
  type: actionTypes.GET_SURVEY,
  callback,
  payload: id,
});

export const getSurveySuccess = data => ({
  type: actionTypes.GET_SURVEY_SUCCESS,
  payload: data,
});

export const updateSurvey = (data, callback = (_res: boolean, _message: string) => {}) => ({
  type: actionTypes.UPDATE_SURVEY,
  callback,
  payload: data,
});

export const updateSurveySuccess = data => ({
  type: actionTypes.UPDATE_SURVEY_SUCCESS,
  payload: data,
});

export const getStaticValues = () => ({
  type: actionTypes.GET_STATIC_VALUES,
});

export const getStaticValuesSuccess = data => ({
  type: actionTypes.GET_STATIC_VALUES_SUCCESS,
  payload: data,
});

export const createSurveySeries = (
  data,
  callback = (_res: { message: string; surveySeries: { id: string; name: string } }, _message: string) => {},
) => ({
  type: actionTypes.CREATE_SURVEY_SERIES,
  payload: data,
  callback,
});

export const createSurveySeriesSuccess = data => ({
  type: actionTypes.CREATE_SURVEY_SERIES_SUCCESS,
  payload: data,
});

export const getSurveySeries = (
  data,
  callback = (_res: { message: string; surveySeries: { id: string; name: string } }, _message: string) => {},
) => ({
  type: actionTypes.GET_SURVEY_SERIES,
  payload: data,
  callback,
});

export const getSurveySeriesSuccess = data => ({
  type: actionTypes.GET_SURVEY_SERIES_SUCCESS,
  payload: data,
});

export const getSurveySeriesById = (id: string, callback = (_res: { id: string }, _message: string) => {}) => ({
  type: actionTypes.GET_SURVEY_SERIES_BY_ID,
  payload: id,
  callback,
});

export const getSurveySeriesByIdSuccess = data => ({
  type: actionTypes.GET_SURVEY_SERIES_BY_ID_SUCCESS,
  payload: data,
});

export const cloneSurvey = (data, callback = (_res: { id: string }, _message: string) => {}) => ({
  type: actionTypes.CLONE_SURVEY,
  callback,
  payload: data,
});

export const closeSurvey = (data, callback = (_res: { closedSurvey: any }, _message: string) => {}) => ({
  type: actionTypes.CLOSE_SURVEY,
  callback,
  payload: data,
});

export const publishSurvey = (
  data,
  callback = (_res: { publishedSurvey: any; message: string }, _message: string) => {},
) => ({
  type: actionTypes.PUBLISH_SURVEY,
  callback,
  payload: data,
});

export const updateSurveySeries = (
  data,
  callback = (_res: { message: string; surveySeries: { id: string; name: string } }, _message: string) => {},
) => ({
  type: actionTypes.UPDATE_SURVEY_SERIES,
  payload: data,
  callback,
});

export const reopenSurvey = (data, callback = (_res: { reopenedSurvey: any }, _message: string) => {}) => ({
  type: actionTypes.REOPEN_SURVEY,
  callback,
  payload: data,
});

export const saveNotes = (data: { id: string; notes: string }, callback = (_res: boolean, _message: string) => {}) => ({
  type: actionTypes.SAVE_NOTES,
  payload: data,
  callback,
});

export const getCCEmail = (callback = (_: string) => {}) => ({
  type: actionTypes.GET_CC_EMAIL,
  callback,
});

export const updateCCEmail = (data: string, callback = (_res: boolean, _message: string) => {}) => ({
  type: actionTypes.UPDATE_CC_EMAIL,
  payload: data,
  callback,
});
